"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDeprecatedQuickAmounts = exports.getQuickAmounts = exports.validateQuickAmount = exports.useGetUserSettingsData = exports.useSetUserSetting = void 0;
const react_redux_1 = require("react-redux");
const react_1 = require("react");
const js_cookie_1 = __importDefault(require("js-cookie"));
const selectors_1 = require("../AccountProvider/selectors");
const utils_1 = require("../../utils");
const constants_1 = require("./constants");
const slice_1 = require("./slice");
const types_1 = require("./types");
const useSetUserSetting = () => {
    // When change data after setSettingsDataSuccess will update data in cookie by using additional saga
    const dispatch = (0, react_redux_1.useDispatch)();
    const accountId = (0, react_redux_1.useSelector)(selectors_1.selectAccountId);
    const onSetUserSetting = (0, react_1.useCallback)((data) => {
        if (accountId) {
            dispatch(slice_1.settingsProviderActions.setSettingsData(data));
        }
        else {
            dispatch(slice_1.settingsProviderActions.setSettingsDataSuccess(data));
            // Using setSettingsDataSuccess because don't do require request data from server for get user settings from back-end
        }
    }, [accountId, dispatch]);
    return { onSetUserSetting };
};
exports.useSetUserSetting = useSetUserSetting;
const useGetUserSettingsData = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const accountId = (0, react_redux_1.useSelector)(selectors_1.selectAccountId);
    (0, react_1.useEffect)(() => {
        if (!accountId) {
            const settingDataCookieString = js_cookie_1.default.get(constants_1.COOKIE_USER_SETTINGS_NAME);
            dispatch(slice_1.settingsProviderActions.getSettingsDataSuccess(settingDataCookieString
                ? JSON.parse(settingDataCookieString)
                : constants_1.DEFAULT_SETTINGS) // Setting initial value of store here because we must set cookie by using saga
            );
        }
    }, [accountId, dispatch]);
};
exports.useGetUserSettingsData = useGetUserSettingsData;
const validateQuickAmount = (value, minValue, amountsCount, maxValue) => {
    if (value < minValue) {
        return types_1.ValidateAmountErrors.minValueError;
    }
    if (maxValue && value > maxValue) {
        return types_1.ValidateAmountErrors.maxValueError;
    }
    if (amountsCount > constants_1.maxAmountsCount) {
        return types_1.ValidateAmountErrors.amountsCountError;
    }
    return null;
};
exports.validateQuickAmount = validateQuickAmount;
// Get quick settings for amounts to use based on the data you have.
const getQuickAmounts = (defaultSettings, settings, quickAmounts) => {
    const parsedSettings = (0, utils_1.jsonParse)(settings !== null && settings !== void 0 ? settings : '', {});
    if (parsedSettings.quickAmountsSettings) {
        return (0, exports.convertDeprecatedQuickAmounts)(parsedSettings.quickAmountsSettings);
    }
    return quickAmounts !== null && quickAmounts !== void 0 ? quickAmounts : defaultSettings;
};
exports.getQuickAmounts = getQuickAmounts;
// Converts deprecated quick amounts settings to the updated QuickAmounts format.
// TODO delete after migration complete
const convertDeprecatedQuickAmounts = (settings) => {
    const { quickAmounts, quickAmountsType } = settings;
    return {
        quickAmountsType: constants_1.quickAmountsTypeMap[quickAmountsType],
        fixedAmounts: quickAmounts[types_1.QuickAmountsTypesDeprecated.sum].map((item) => (0, utils_1.adjustAmountForBackend)(item)),
        balancePercents: quickAmounts[types_1.QuickAmountsTypesDeprecated.percent],
    };
};
exports.convertDeprecatedQuickAmounts = convertDeprecatedQuickAmounts;
//# sourceMappingURL=utils.js.map